import { render, staticRenderFns } from "./NewsDt.vue?vue&type=template&id=56e14e6c&scoped=true&"
import script from "./NewsDt.vue?vue&type=script&lang=js&"
export * from "./NewsDt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e14e6c",
  null
  
)

export default component.exports